import { render, staticRenderFns } from "./PriceEditForm.vue?vue&type=template&id=b4fa8b90"
import script from "./PriceEditForm.vue?vue&type=script&lang=ts"
export * from "./PriceEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports